import React from 'react';
import { Collapse, Alert, Text, HStack } from 'native-base';

export interface LocalComponentErrorProps {
  error?: string;
}

export function LocalComponentError({ error }: LocalComponentErrorProps) {
  return (
    <Collapse isOpen={error !== undefined}>
      <Alert w="full" variant="left-accent" status="error">
        <HStack space={2} width={'full'}>
          <Alert.Icon mt="1" />
          <Text
            fontSize="lg"
            color="surface.100"
            fontFamily="body"
            fontStyle="normal"
            fontWeight={'medium'}
          >
            {error ?? 'An error occurred, please try again later.'}
          </Text>
        </HStack>
      </Alert>
    </Collapse>
  );
}

export default LocalComponentError;
